import http from "./httpService";
import { apiUrl } from "../config";

import { getPlanID } from "../utils/planAccessors";

function listPlans() {
    return http.get(apiUrl + "/public-api/plans");
}

function subscribe(plan, options = {}) {
    return http.post(apiUrl + "/api/subscriptions/create", {
        "plan_id": parseInt(getPlanID(plan)),
        "redirect_url": window.location.origin+"/w/subscriptions",
        "confirm_individual_purchase": !!options.confirmIndividualPurchase,
    });
}

function cancel(subscriptionID) {
    return http.post(apiUrl + "/api/subscriptions/"+String(subscriptionID)+"/cancel");
}

function listSubscriptions() {
    return http.get(apiUrl + "/api/subscriptions/all");
}

function reconcileLatestPayment(transactionID) {
    return http.post(apiUrl + "/api/subscriptions/reconcile-latest-payment", {
        "transaction_id": transactionID || "",
    });
}

export default {
    listPlans,
    listSubscriptions,
    cancel,
    subscribe,
    reconcileLatestPayment,
};
